import createReactComponent from '../createReactComponent';
export default createReactComponent('chart-no-axes-column-decreasing', 'ChartNoAxesColumnDecreasing', [["path",{"d":"M7 21V3m5 18V9m5 12v-5","key":"svg-0"}]]);